import { ReactElement } from 'react'
import { I18N } from 'typings/custom'
import NoMarginAlertBanner from './NoMarginAlertBanner'

/**
 * Banner used to display high risk device error
 */
const DeviceErrorAlertBanner = ({ i18n }: { i18n: I18N }): ReactElement => {
  return (
    <NoMarginAlertBanner type="error" scrollToOnMount>
      {i18n({
        resetPassword:
          'Our system has detected this device may not be secure. Try again from another device, preferably one that only you can access'
      })}
    </NoMarginAlertBanner>
  )
}

export default DeviceErrorAlertBanner
